import { render } from "./UpdateCategoryModal.vue?vue&type=template&id=e1fdbfd2&ts=true"
import script from "./UpdateCategoryModal.vue?vue&type=script&lang=ts"
export * from "./UpdateCategoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__